import React from 'react';
import PropTypes from 'prop-types';

import { StyledLabel } from './RadioBtnStyles';

var RadioBtn = function RadioBtn(props) {
  return React.createElement(
    StyledLabel,
    {
      htmlFor: props.htmlFor,
      active: props.active,
      optionAvailable: props.optionAvailable
    },
    props.value
  );
};

RadioBtn.propTypes = {
  active: PropTypes.bool.isRequired,
  optionAvailable: PropTypes.bool,
  value: PropTypes.string.isRequired,
  htmlFor: PropTypes.string.isRequired
};

export default React.memo(RadioBtn);